import { render, staticRenderFns } from "./bigPreview.vue?vue&type=template&id=ea4aaa68&scoped=true"
import script from "./bigPreview.vue?vue&type=script&lang=js"
export * from "./bigPreview.vue?vue&type=script&lang=js"
import style0 from "./bigPreview.vue?vue&type=style&index=0&id=ea4aaa68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4aaa68",
  null
  
)

export default component.exports